import { createAsyncThunk } from "@reduxjs/toolkit";
import { captureException } from "@sentry/react";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";

interface UnSkipSubscriptionProps {
  userId: number;
}

export const unSkipSubscription = createAsyncThunk<void, UnSkipSubscriptionProps, ThunkConfig<ApiError>>(
  "subscription/unSkipSubscription",
  async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      await extra.api.post("/api/subscription/unskip_subscription", params);
    } catch (err) {
      captureException(err);

      return rejectWithValue(handleError(err));
    }
  }
);
